import React from 'react';
import { NavLink } from 'react-router-dom';


const Navbar = ()=> {
  return (
    <>
    <div className="container-fluid nav_bg">
        <div className='row'>
            <div className="col-10 mx-auto">

       
        <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid">
            <NavLink activeClassName = "menu_active" exact className="navbar-brand" to="/">TriLine</NavLink>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse justify-content-end" id="navbarSupportedContent">
            <ul className="navbar-nav ml-auto mb-2 mb-lg-0">
                <li className="nav-item">
                <NavLink activeClassName = "menu_active" exact className="nav-link active" aria-current="page" to="/">Home</NavLink>
                </li>
                <li className="nav-item">
                <NavLink activeClassName = "menu_active" exact className="nav-link" to="/service">Services</NavLink>
                </li>
                <li className="nav-item">
                <NavLink activeClassName = "menu_active" exact className="nav-link" to="/about">About Us</NavLink>
                </li>
                <li className="nav-item">
                <NavLink activeClassName = "menu_active" exact className="nav-link" to="/contact">Contact Us</NavLink>
                </li>
                
                {/* <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Dropdown
                </a>
                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li><a className="dropdown-item" href="#">Action</a></li>
                    <li><a className="dropdown-item" href="#">Another action</a></li>
                    <li><hr className="dropdown-divider" /></li>
                    <li><a className="dropdown-item" href="#">Something else here</a></li>
                </ul>
                </li> */}
                {/* <li className="nav-item">
                <a className="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">Disabled</a>
                </li> */}
            </ul>
            {/* <form className="d-flex">
                <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
                <button className="btn btn-outline-success" type="submit">Search</button>
            </form> */}
            </div>
        </div>
        </nav>
        </div>
        </div>
      </div> 
    </>
  );
};

export default Navbar;